import React from "react";

export function useTabs(initialTab) {
    const [activeTab, setActiveTab] = React.useState(null);
    
    React.useEffect(() => {
        if (initialTab !== undefined && initialTab !== null) {
            setActiveTab(initialTab);
        }
    }, []);
    
    return { activeTab, setActiveTab };
}